/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for aggregateMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="aggregateMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="dynamic"/&gt; &lt;enumeration value="static"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class AggregateMode extends Enum{

	enumValue = null;

	static  DYNAMIC = AggregateMode.newLiteral("dynamic");

	static  STATIC = AggregateMode.newLiteral("static");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < AggregateMode.values().length); ++i) {
			if (AggregateMode.values()[i].enumValue == v) {
				return AggregateMode.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("AggregateMode" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/AggregateMode.js